import { createSelector } from 'reselect';

const selectOrganizationSettings = (state: any) => state.organizationSettings;


export const selectOrganizationSettingsCurrentItem = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.current);

export const selectOrganizationSettingsListItems = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.list);

export const selectOrganizationSettingsItemById = (itemId: any) =>
    createSelector(selectOrganizationSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOrganizationSettingsQueryItems = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.query);

export const selectOrganizationSettingsCreatedItem = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.create);

export const selectOrganizationSettingsUpdatedItem = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.update);

export const selectOrganizationSettingsReadItem = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.read);

export const selectOrganizationSettingsDeletedItem = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.delete);

export const selectOrganizationSettingsSearchedItems = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.search);

export const selectOrganizationSettingsItemsCount = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.count);

export const selectOrganizationSettingsItemsFilter = createSelector([selectOrganizationSettings], (organizationSettings) => organizationSettings.filter);